import React, { FunctionComponent } from 'react';
import {
  CardListItem,
  CardListItemProps
} from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { EditTimeTrackingConfigurationDialog } from '../EditTimeTrackingConfigurationDialog/EditTimeTrackingConfigurationDialog';
import { useTimeTrackingConfigurationDeleteHandler } from '../../../hooks/entity/deleteHandler/useTimeTrackingConfigurationDeleteHandler';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';

export type TimeTrackingConfigurationListItemProps = CardListItemProps & {
  readonly timeTrackingConfiguration: TimeTrackingConfiguration;
};

export const TimeTrackingConfigurationListItem: FunctionComponent<
  TimeTrackingConfigurationListItemProps
> = (props) => {
  const { timeTrackingConfiguration, ...remainingProps } = props;

  const {
    open: openEditDialog,
    close: closeEditDialog,
    modalProps
  } = useModalOpened({});

  const handleDeleteClick = useTimeTrackingConfigurationDeleteHandler(
    timeTrackingConfiguration
  );

  return (
    <>
      <CardListItem {...remainingProps}>
        <CardListItemTitle>{timeTrackingConfiguration.name}</CardListItemTitle>
        <CardListItemIconButton
          {...iconConfigurations.prefixed.listItem.deleteIcon}
          onClick={handleDeleteClick}
        ></CardListItemIconButton>
        <CardListItemIconButton
          {...iconConfigurations.prefixed.listItem.editInDialogIcon}
          onClick={openEditDialog}
          data-testid="TimeTrackingConfigurationListItem.EditButton"
        ></CardListItemIconButton>
      </CardListItem>
      <EditTimeTrackingConfigurationDialog
        {...modalProps}
        timeTrackingConfiguration={timeTrackingConfiguration}
        onAccept={closeEditDialog}
        data-testid="TimeTrackingConfigurationListItem.EditDialog"
      ></EditTimeTrackingConfigurationDialog>
    </>
  );
};
